import { Tooltip } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import * as S from './ImageLink.styled';

function ImageLink({ imagem, uri, alt, tooltip }) {
  function onClick() {
    if (uri) {
      const redirect = !uri.match(/http(s)*:\/\//g) ? `http://${uri}` : uri;
      window.open(redirect);
    }
  }

  return (
    <Tooltip title={tooltip}>
      <S.ImageLink
        onKeyDown={event => {
          if (event.keyCode === 13) onClick();
        }}
        onClick={onClick}
        tabIndex={0}
        src={`data:image/png;base64, ${imagem}`}
        alt={alt}
      ></S.ImageLink>
    </Tooltip>
  );
}

export default withRouter(ImageLink);
